import { useEvent } from '@emerald-works/react-event-bus-client'
import { useCallback } from 'react'
import { HOME_SECTION_TYPE } from '../components/sections/home-sections'

export const HOME_ENTERPRISE_EVENT_TYPE = {
  CLICK: 'click',
  ARTICLE_CLICK: 'articleClick',
  VIEWED: 'viewed',
  EXITED: 'exited',
  SCROLL: 'scroll',
  SKILL_BITE_CLICK: 'skillBiteClick',
  ONBOARDING: 'onboarding',
  SKILL_BUILDER_CLICK: 'skillBuilderClick'
}

export const HOME_ENTERPRISE_ONBOARDING_EVENT_TYPE = {
  BANNER_SHOWN: 'homepage_banner_shown',
  BANNER_CLICKED: 'homepage_banner_cta_clicked',
  LOGO_CLICKED: 'homepage_logo_clicked'
}

export const useTrackHomeEnterpriseEvent = () => {
  const [homeEnterpriseEvent] = useEvent([{
    eventName: 'homeEnterpriseEvent'
  }])

  const trackClickEvent = useCallback((rail, data) => {
    homeEnterpriseEvent.trigger({
      eventType: HOME_ENTERPRISE_EVENT_TYPE.CLICK,
      data: {
        rail,
        ...data
      }
    })
  }, [homeEnterpriseEvent])

  const trackArticleClickEvent = useCallback((rail, locationId, extraData) => {
    homeEnterpriseEvent.trigger({
      eventType: HOME_ENTERPRISE_EVENT_TYPE.ARTICLE_CLICK,
      data: {
        rail,
        locationId,
        ...extraData
      }
    })
  }, [homeEnterpriseEvent])

  const trackSkillBuilderClickEvent = useCallback((skillBuilderId, extraData) => {
    homeEnterpriseEvent.trigger({
      eventType: HOME_ENTERPRISE_EVENT_TYPE.SKILL_BUILDER_CLICK,
      data: {
        skillBuilderId,
        rail: HOME_SECTION_TYPE.MSB,
        ...extraData
      }
    })
  }, [homeEnterpriseEvent])

  const trackScrollEvent = useCallback((scrollDepthPercentage) => {
    homeEnterpriseEvent.trigger({
      eventType: HOME_ENTERPRISE_EVENT_TYPE.SCROLL,
      data: {
        scrollDepthPercentage
      }
    })
  }, [homeEnterpriseEvent])

  const trackSkillBiteClickEvent = useCallback((skillBiteId, extraData) => {
    homeEnterpriseEvent.trigger({
      eventType: HOME_ENTERPRISE_EVENT_TYPE.SKILL_BITE_CLICK,
      data: {
        rail: HOME_SECTION_TYPE.SKILL_BITE,
        ...extraData,
        skillBiteId
      }
    })
  }, [homeEnterpriseEvent])

  const trackOnboardingEvent = useCallback((eventType, extraData = {}) => {
    homeEnterpriseEvent.trigger({
      eventType: HOME_ENTERPRISE_EVENT_TYPE.ONBOARDING,
      data: {
        event: eventType,
        ...extraData
      }
    })
  }, [homeEnterpriseEvent])

  const trackViewedEvent = useCallback(() => {
    homeEnterpriseEvent.trigger({
      eventType: HOME_ENTERPRISE_EVENT_TYPE.VIEWED
    })
  }, [homeEnterpriseEvent])

  const trackExitedEvent = useCallback((timeSpentOnPage) => {
    homeEnterpriseEvent.trigger({
      eventType: HOME_ENTERPRISE_EVENT_TYPE.EXITED,
      data: {
        timeSpentOnPage
      }
    })
  }, [homeEnterpriseEvent])

  return {
    EVENT_TYPE: HOME_ENTERPRISE_EVENT_TYPE,
    trackScrollEvent,
    trackViewedEvent,
    trackExitedEvent,
    trackClickEvent,
    trackSkillBiteClickEvent,
    trackArticleClickEvent,
    trackOnboardingEvent,
    trackSkillBuilderClickEvent,
    HOME_SECTION_TYPE
  }
}
